const TermsPage = () => (
	<div className="min-h-screen bg-[#18181B]">
		<div className="max-w-4xl mx-auto px-4 py-10 text-[#ffffff] space-y-6">
			<h1 className="text-3xl font-bold flex items-center justify-center">
				Terms of Service
			</h1>
			<p className="text-center text-[#BABABB]">Revised: November 23, 2025</p>

		<section>
			<p>
				Welcome to the SECH website located at Sech.io and the SECH mobile app,
				provided by SECH Technologies LLC ("SECH", "We", "Our", or the
				"Company").
			</p>
			<br/>
			<p>
				The following Terms of Service (the "Terms") govern your access to and
				use of the Sech.io website and the SECH mobile app (collectively, the
				"Online Platform"). Certain sections of the Terms govern your user
				account and the associated wallet (your "SECH Account") included in and
				accessed via the Online Platform, and usage of the SECH tokens with
				participating hospitality providers. All use of the Online Platform and
				your SECH Account is subject to these Terms.
			</p>
			<br/>
			<p>
				By applying for a SECH Account or using the Online Platform, you
				acknowledge that you have read, understood and agree to comply with the
				Terms. If you do not agree with anything contained in the Terms, please
				do not submit information to, access information from, or otherwise
				utilize the Online Platform.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Overview of SECH Services
			</h2>
			<p>
				The SECH token enables virtual electronic payments. Specifically, the
				SECH token provides (1) a seamless, private method of making direct
				payments within the Secrets Hideaway Resort and other partner clubs, (2)
				a mechanism for the club to deliver loyalty rewards such as member-only
				discounts, VIP access to premium experiences, and other perquisites to
				Resort guests who adopt and use the SECH token, and (3) a currency for
				the upcoming Secrets metaverse.
			</p>
			<br/>
			<p>
				The SECH Mobile App implements and supports various functionalities of
				the SECH token. The SECH app can be downloaded from the Apple and Google
				stores and operates on both iOS and Android devices. The SECH app allows
				users to: (1) Open a user account and create a wallet, (2) purchase SECH
				tokens, (3) display the user's SECH wallet balance, (4) purchase
				memberships and day passes, (5) order and pay for food and beverages,
				(6) make other payments for goods and services throughout the Resort,
				and (7) receive Resort events announcements, news and offers.
			</p>
			<br/>
			<p>
				The value of each SECH token at any particular time is determined by its
				sale price on the public Arbitrum token market. The value of your SECH
				tokens may change (either increase or decrease) after you obtain them.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Performing Transactions
			</h2>

			<h3 className="text-xl font-semibold mt-4 mb-2">
				1. Purchasing SECH tokens in the Mobile App
			</h3>
			<p>
				a. You can purchase SECH tokens through our service provider BANXA by
				using the Mobile App.
			</p>
			<br/>
			<p>
				b. The Mobile App sells SECH tokens for the current market price as
				quoted on Arbitrum in USDC. This market price varies over time based on
				supply and demand.
			</p>
			<br/>
			<p>
				c. When you purchase SECH tokens in the Mobile App, we display the user
				interface of our financial service provider BANXA in the SECH App. By
				proceeding, you are purchasing SECH tokens from BANXA and not from the
				Company. When purchasing tokens through BANXA, you agree to comply with
				and accept BANXA's terms and conditions and privacy policy.
			</p>
			<br/>
			<p>
				d. BANXA will deposit the SECH tokens you purchase in the Wallet
				associated with your Mobile App Account.
			</p>
			<br/>
			<p>
				e. <span className="font-medium">Payment & Processing Disclaimer:</span> Fiat on-ramp and card processing services for purchases of SECH Tokens are provided solely by Banxa and are subject to Banxa's own terms, conditions, and compliance requirements. The SECH App and its affiliates do not provide payment services and are not responsible for any bank or card-issuer decisions, including declined transactions, fees, holds, or chargebacks. At this time, Banxa supports eligible bank debit cards only. Credit cards, including Visa and Mastercard credit products, are not supported, and transactions attempted with such cards may fail or be reversed. By proceeding, you confirm that you are using a valid debit card and that all payment processing is performed by Banxa, not the SECH App. This notice is for informational purposes only and does not constitute financial, legal, or tax advice.
			</p>

			<h3 className="text-xl font-semibold mt-4 mb-2">
				2. Trading SECH Tokens on Decentralized Exchanges
			</h3>
			<p>
				a. You may choose to obtain or dispose of SECH tokens on a decentralized
				exchange where the SECH tokens are listed.
			</p>
			<br/>
			<p>
				b. For example, you may choose to obtain SECH tokens by obtaining
				virtual currency tokens (such as ETH) residing on the Arbitrum network
				and trading the ETH for the SECH tokens on the decentralized exchange.
				Tokens you obtain will typically be deposited to a wallet that you
				identify during the transaction.
			</p>
			<br/>
			<p>
				c. Similarly, you may choose to trade SECH tokens that you own for other
				tokens available on an exchange.
			</p>
			<br/>
			<p>
				d. The Company does not operate or control any decentralized exchanges
				and is unable to assist you with those transactions. As a courtesy, the
				Company may provide information or instructions relating to
				decentralized exchange transactions, but all such information is
				provided as-is and without any warranty regarding its accuracy.
				Information provided may not be up-to-date, and You must independently
				verify the steps required to perform any transaction before proceeding.
			</p>
			<br/>
			<p>
				e. You agree that you are solely responsible for all interactions and
				transactions you perform involving decentralized exchanges, and you will
				hold the Company harmless for any operational failures, losses,
				injuries, or damages that you experience.
			</p>

			<h3 className="text-xl font-semibold mt-4 mb-2">
				3. Redeeming SECH to pay for goods or services
			</h3>
			<p>
				a. You can make cashless, cardless payments for goods and services at
				participating resorts using the Mobile App.
			</p>
			<br/>
			<p>b. The goods and services you obtain may be priced in SECH or in U.S. Dollars.</p>
			<br/>
			<p>
				c. If the price to be paid is quoted in US Dollars, the SECH token will
				be valued at its then-current Arbitrum market price for payment
				purposes. A number of SECH tokens equal to the quoted price divided by
				the SECH market price will be deducted from your SECH wallet to make the
				payment.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Transaction Limitations, Restrictions, and Procedures
			</h2>
			<p>
				1. You represent and agree that you will purchase SECH tokens only for
				your reasonably anticipated personal consumptive use in paying for goods
				and services at participating resorts and facilities, and not for
				speculative or investment purposes, and without any expectation of
				profit or other financial return based on the efforts of SECH or any
				third party.
			</p>
			<br/>
			<p>
				2. You agree that the Company is not responsible for any delay in the
				settlement of a transaction resulting from circumstances beyond Our
				reasonable control, or the failure of any other person or party
				(including You and our Service Providers) to perform all necessary steps
				to enable the completion of a transaction.
			</p>
			<br/>
			<p>
				3. If there is a pricing error when you buy or sell SECH (that is, the
				buy or sell price shown is substantially inconsistent with the market
				price at the time of execution) the Company reserves the right to
				correct such errors, and/or reverse the erroneous transaction.
			</p>
			<br/>
			<p className="uppercase font-semibold">
				4. IF A FUNDING TRANSACTION FAILS OR IS REVERSED BY BANXA OR A BANK,
				PAYMENT PROCESSOR OR SIMILAR ENTITY, RESULTING IN A BALANCE OWING TO US,
				YOU AGREE THAT WE MAY, WITHOUT NOTICE TO YOU, LIQUIDATE THE SECH TOKENS
				IN YOUR WALLET AS NEEDED IN ORDER TO REPAY ANY SUCH AMOUNTS OWING TO US.
				TO THE EXTENT THERE IS ANY SHORTFALL IN AMOUNTS OWING TO US, YOU AGREE
				TO PROMPTLY PAY US SUCH AMOUNTS.
			</p>
			<br/>
			<p>
				5. Access to the Online Platform may be degraded or unavailable during
				periods of significant volume or volatility. This could result in the
				inability to buy or sell and delays in support response. We do not
				guarantee that any order will be executed, accepted, or recorded. The
				Company shall not be liable for any losses arising out of transaction
				delays. There is also no guarantee that a submitted purchase order will
				be filled. The Company reserves the right to refuse or cancel any order
				placed through the Online Platform for any reason, including, but not
				limited to, order size, market conditions, Your breach of this
				Agreement, actual, potential, or perceived violation of any applicable
				laws, rules or regulations, abnormal market conditions, significant
				disruption in trading or the market or an exchange where it is traded,
				insufficient or inadequate funds in the Account, inability to access
				required liquidity, operational failure of our Service Providers. If the
				Company refuses or cancels an order, the Company will not have any
				liability to you for the refusal or cancellation.
			</p>
			<br/>
			<p>
				6. We may restrict funding methods and limit funding amounts for Your
				account. To prevent fraud and reduce risk, We may at any time, without
				liability to You, place holds on Your account that restrict Your ability
				to (1) deposit and/or purchase SECH, and/or (2) make payments with SECH
				tokens.
			</p>
			<br/>
			<p>
				7. If we determine in our sole discretion that the SECH tokens you hold
				were wrongfully acquired or were acquired by violating a provision of
				this Agreement, we have the right to, but are not obligated to, act in
				response to such wrongful acts as we deem fair and appropriate, in our
				sole discretion.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Resort Disputes, Transaction Errors, and Refunds
			</h2>
			<p>
				<span className="font-medium">Resort Responsibility.</span> Partner
				Venues are solely responsible for the goods and services they provide.
				Any disputes regarding accommodations, food and beverage, entertainment,
				events, billing, or service quality must be directed to the applicable
				Partner Venue.
			</p>
			<br/>
			<p>
				<span className="font-medium">Transaction Errors.</span> If you believe
				a SECH Token transaction was unauthorized or processed in error, you
				must notify SECH in writing within thirty (30) days of the transaction
				appearing in your account records. SECH will use reasonable efforts to
				investigate and, where appropriate, may issue a token credit or
				adjustment.
			</p>
			<br/>
			<p>
				<span className="font-medium">Refunds.</span> Unless required by law or
				expressly stated by SECH or a Partner Venue, SECH does not provide cash
				refunds. Where a refund is authorized, it may be provided in SECH Tokens
				or as a credit toward future purchases.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Service Providers</h2>
			<p>
				Our Service uses third-party Service Providers to perform some
				functions. By using the Service, You authorize us to use third-party
				Service Providers in delivering the Service, including BANXA. Each of
				our Service Providers has applicable terms of service, and those terms
				will apply to You when they provide services supporting your account.
				Terms of service of these Service Providers are available for your
				review at the time you interact with them to provide them with
				information, or from the Company by written request. Although we believe
				that our Service Providers have implemented reasonable and appropriate
				terms of service and limitations of their liability, we have no control
				over and assume no responsibility for their terms of service or their
				implementation of such terms. We also assume no responsibility to notify
				you of any changes in their terms of service.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Modifications to the Terms of Service
			</h2>
			<p>
				SECH reserves the right to make changes to these Terms at any time. It
				is your responsibility to review the Terms from time to time to see if
				modifications have been made. Your continued use of the Online Platform
				after any modification of the Terms will conclusively indicate that you
				accept those changes. Notwithstanding the above, we will seek your
				consent to future modifications to the Terms to the extent we are
				required to do so by law.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Electronic Communication
			</h2>
			<p>
				We, or our Service Providers and affiliated entities, may be required to
				provide certain legal and regulatory disclosures, periodic statements
				and confirmations, notices, tax forms and other communications
				(collectively "Communications") to you in written form. By agreeing to
				these Terms, you consent to SECH and its Service Providers delivering
				such Communications to you in electronic form, including e-mail. Consent
				for electronic delivery applies to every year the Communications are
				furnished. If you no longer have access to your account to receive the
				Communications in electronic format, then you may provide the Company
				with another e-mail address or request the Communications in written
				form.
			</p>
			<br/>
			<p>
				You agree that all terms and conditions, agreements, notices,
				disclosures and other communications that we provide to you
				electronically satisfy any legal requirement such communications would
				satisfy if they were provided in writing. SECH will use reasonable
				efforts to honor any request you may have to opt out from receiving
				certain e-mails. With respect to these Terms, you waive any rights to
				require an original (non-electronic) signature or delivery or retention
				of non-electronic records, to the extent such waiver is not prohibited
				under applicable law.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Privacy Policy</h2>
			<p>
				Your privacy is very important to us. We encourage you to read SECH's
				Privacy Policy (located at{' '}
				<a href="https://sech.io/privacy-policy" className="text-[#EF4444] hover:text-[#DC2626]">
					https://sech.io/privacy-policy
				</a>
				) (the "Privacy Policy"). The Privacy Policy explains how we treat your
				personal information when you are using the Online Platform. By using
				the Online Platform, you agree that SECH may use your personal
				information as set forth in the Privacy Policy. SECH's Privacy Policy is
				hereby incorporated in the Terms by reference in its entirety.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Registration</h2>
			<p>
				To use transactional features of the Online Platform, you must complete
				the registration process. Once registered, a SECH account and wallet
				will be created for you to access the Online Platform and other
				resources.
			</p>
			<br/>
			<p>
				These additional terms may be modified from time to time, and the
				modified terms shall also be incorporated into these Terms of Service by
				reference.
			</p>
			<br/>
			<p>
				You agree that the registration information you provide will be
				accurate, complete and current. You further agree to promptly update
				that information to keep it accurate, complete and current.
			</p>
			<br/>
			<p>
				If you are permitted to register on behalf of a business entity or other
				organization, you represent and warrant that you have the authority to
				provide the information required and to bind the organization to the
				Terms.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Potentially Fraudulent Activity
			</h2>
			<p>
				Any actual or suspected unauthorized access or unauthorized activity
				will be treated by us as potentially fraudulent ("Potentially Fraudulent
				Activity"). You agree to notify us immediately if you become aware of or
				suspect any Potentially Fraudulent Activity. For avoidance of doubt, you
				are deemed to be aware of Potentially Fraudulent Activity upon receipt
				of any notice of the occurrence of such activity. Upon receipt of
				written notice from you of any Potentially Fraudulent Activity, we will
				take reasonable steps to protect your SECH Account, including, for
				example, by temporarily restricting access to your SECH Account,
				suspending any pending transactions, or requiring you to change your
				login credentials. You agree to promptly report any Potentially
				Fraudulent Activity to legal authorities if required by applicable law,
				and to provide us a copy of any report prepared by such legal
				authorities. In the event of a legal investigation of any Potentially
				Fraudulent Activity, you further agree to (i) cooperate fully with the
				legal authorities and SECH in such investigation; (ii) complete any
				required affidavits promptly, accurately and thoroughly; and (iii) allow
				SECH, or any third-party designated by us, access to your mobile device,
				computer, and network as may be relevant to such investigation. Failure
				to cooperate in any such investigation may cause delays in regaining
				access to your SECH Account and any funds held within.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Acceptable Use of the Online Platform
			</h2>
			<p>
				You agree that any information that you provide (about your identity,
				finances, and relationships) is accurate, correct, and up to date. You
				agree that you are 18 years of age or older; able to form a binding
				contract with us; and are acting on your own behalf (and have not been
				banned, terminated, or otherwise denied access to the Online Platform by
				SECH or by law).
			</p>
			<br/>
			<p>
				Accessing the information, resources, services, products and tools of
				this Online Platform by any other means than we provide is strictly
				prohibited. You specifically agree not to access or tamper with the
				Online Platform, for any purpose, through any automated, unethical or
				unconventional means, including accessing or collecting personally
				identifiable information or account information (including usernames,
				passwords, e-mail addresses or other personal, financial or contact
				information) with respect to SECH users, borrowers, investors, lenders
				or employees.
			</p>
			<br/>
			<p>
				You may not violate, interfere with, impair or circumvent the ordinary
				operation, security, privacy or mission of the Online Platform or SECH's
				products, services or data, including overburdening, spamming, engaging
				in a denial-of-service attack or similar activities (or attempt to do
				any of the above).
			</p>
			<br/>
			<p>
				You will not transmit to SECH or make available on or upload any
				information to the Online Platform that: (i) is commercial or
				promotional in nature; (ii) is unlawful, harmful, deceptive, or
				otherwise violates the legal rights or privacy of others; (iii) is
				capable of giving rise to legal action whether against you or SECH or
				any affiliate third party; (iv) infringes any patent, trademark, trade
				secret, copyright, or other property rights of any party; (v)
				impersonates any person or entity (including SECH or its employees and
				representatives); or (vi) contains viruses, malware or any program, code
				or technology designed to disrupt, intercept, impair or destroy the
				functionality of the Online Platform or its software, data or network.
			</p>
			<br/>
			<p>
				<span className="font-medium">Guest Privacy and Consent.</span> Because
				Partner Venues operate in private, adults-only environments, you may not
				upload, post, share, or distribute any images, videos, audio recordings,
				or other content that depicts or reasonably could identify another
				guest, member, or staff member unless you have obtained their prior,
				written, informed consent. You also may not publish or distribute such
				content outside the SECH App—including on social media or external
				websites—without consent.
			</p>
			<br/>
			<p>
				SECH reserves the right to edit, restrict or remove any content you
				provide for any reason at any time. In addition, SECH does not control
				any information provided by other users that may be made available on or
				through the Online Platform. Notwithstanding SECH's rights under the
				Terms, SECH does not undertake, and shall not be obligated, to monitor
				the submission of any content to, or the publication of any content on,
				the Online Platform at any time. SECH reserves the right to refuse
				service, terminate relationships, and cancel orders or transactions in
				its discretion.
			</p>
			<br/>
			<p>
				By submitting information, feedback or other material to SECH, including
				on or through the Online Platform or your SECH Account, you: (i)
				acknowledge that such information is non-confidential, except for any
				personal and financial information; (ii) grant SECH a perpetual,
				worldwide, royalty-free, irrevocable, transferable, sublicenseable,
				fully paid-up right to copy, use, reproduce, modify, adapt, publish,
				create derivative works from, translate, transmit, display, distribute,
				market, promote, sell or offer for sale, rent or lease such information
				or materials in any form or medium known or later developed; and (iii)
				agree that you will have no claim against SECH for any actual or alleged
				infringement of any proprietary rights, rights of privacy or publicity,
				moral rights or rights of attribution in connection with our use of any
				content you provide.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Network Control</h2>
			<p>
				The SECH token is issued and exchanged in conformance with the ERC-20
				token standard on the Arbitrum blockchain network, an EVM-compatible
				Layer 2 network. SECH does not own or control any of the underlying
				software through which blockchain networks are formed and tokens are
				created and transacted. In general, the underlying software for
				blockchain networks tends to be open source such that anyone can use,
				copy, modify, and distribute it. By using the Online Platform, you
				understand and acknowledge that SECH is not responsible for the
				operation of the underlying software and networks that support the SECH
				token and that SECH makes no guarantee of functionality, security, or
				availability of such software and networks.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Hosted Wallets</h2>
			<p>
				SECH will track the balance and ownership of digital assets stored
				through the SECH Mobile App in a wallet hosted by our Service Providers,
				and you can view the balance of digital assets in your SECH Account
				through the Online Platform. To the extent SECH or its Service Providers
				are authorized to manage SECH Tokens on your behalf through a hosted or
				custodial wallet ("Hosted Wallet"), you acknowledge that the wallet
				services are custodial in nature and that SECH or its service providers
				may hold the private keys associated with such wallet for use as agreed
				upon in these Terms and/or pursuant to your instructions.
			</p>
			<br/>
			<p>
				SECH Tokens and any balances reflected in your Hosted Wallet are not
				bank deposits, are not covered by FDIC or SIPC insurance, and are not
				guaranteed by any governmental or private insurance scheme.
			</p>
			<br/>
			<p>
				<span className="font-medium">Blockchain Irreversibility.</span> You
				understand that blockchain transactions are irreversible once confirmed
				by the network, and SECH cannot reverse or recover SECH Tokens sent to
				an incorrect address or resulting from inaccurate instructions provided
				by you.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Regulatory</h2>
			<p>
				SECH and its Service Providers implement the Bank Secrecy Act and its
				implementing regulations (collectively, the "BSA") which set out the
				requirements imposed upon financial institutions to implement policies
				and procedures reasonably designed to detect and prevent money
				laundering and terrorist financing. Your access to and use of the Online
				Platform is subject to compliance with SECH's Anti-Money-Laundering
				Program. As part of these requirements, when you purchase SECH tokens
				through BANXA you will be required to provide identity information so
				that BANXA can verify compliance with applicable regulations.
			</p>
			<br/>
			<p>
				SECH's Service Providers, including BANXA, maintain licenses to engage
				in activities, and these licenses may impact our provision and your use
				of certain services on the Online Platform depending on where you live.
			</p>
			<br/>
			<p>
				Transactions in digital assets are subject to applicable laws,
				regulations, and rules of federal and state governmental and regulatory
				authorities (collectively, "Applicable Laws"). Compliance with
				Applicable Laws may include compliance with any guidance or direction of
				any regulatory authority or government agency, any writ of attachment,
				lien, levy, subpoena, warrant, or other legal order (collectively,
				"Legal Orders"). You understand and acknowledge that in no event will
				SECH be obligated to affect any transaction it believes would violate
				any Applicable Law. You further understand and acknowledge that SECH is
				not responsible for any losses, whether direct or indirect, that you may
				incur as a result of SECH's good faith efforts to comply with any
				Applicable Law, including any Legal Order.
			</p>
			<br/>
			<p>
				SECH may be required by mobile app platforms (such as Apple's App Store
				or Google Play) or by applicable law or regulation to restrict, modify,
				suspend, or discontinue certain features or services in specific
				countries or jurisdictions, including but not limited to wallet
				functionality, token transfers, or rewards programs. SECH may implement
				any such restrictions or modifications at any time, with or without
				notice, and shall not be liable for any resulting impacts on your access
				to or use of the SECH App.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				SECH's Intellectual Property
			</h2>
			<p>
				All rights, title, and interest in and to the Online Platform and the
				Content (defined below) and all intellectual property contained therein
				or relating thereto, including any copyright, patent or trademark
				rights, are and will remain the exclusive property of SECH or its
				licensors, as applicable. The "Content" includes all contents of the
				Online Platform, including any logos, identifying marks, images,
				illustrations, designs, icons, photographs, videos, text and other
				written and multimedia materials, all of SECH's information (including
				rate information) and requirements, products, services, advertising
				materials or collateral, log-in or registration criteria and
				instructions, help guidelines, user documentation and customer and
				technical support documents, and the Online Platform's likeness, look
				and feel, format, layout, software, code (whether binary, assembly,
				source, object, HTML or otherwise), routines, scripts, software,
				platforms and applications, as well as any data, files, archives,
				folders or downloads available on the Online Platform.
			</p>
			<br/>
			<p>
				Subject to the terms and conditions of the Terms, we grant you a
				limited, non-transferable, non-sublicensable, non-exclusive, revocable
				license to use the Online Platform and the Content for personal use
				until such time as the Terms terminate or expire or your right to use or
				access the Online Platform is terminated in accordance with these Terms.
			</p>
			<br/>
			<p>
				Except as explicitly permitted by these Terms, you may not, and you may
				not allow others to, sell, copy, modify, correct, enhance, create
				derivative works from, publish, store or in any way distribute or
				otherwise exploit, including for any purpose competitive to SECH, any
				Content. You may not, and you may not allow others to: (i) decompile,
				reverse engineer, convert or otherwise extract or disclose the
				underlying script, code (whether binary, assembly, source, object, HTML
				or otherwise) or structure of any Content, or (ii) remove or alter
				authorship attribution or copyright notices or similar information on
				the Online Platform or any products or materials embodying or containing
				any Content.
			</p>
			<br/>
			<p>
				Any violation of the provisions of the Terms regarding SECH's
				Intellectual Property may make you liable for compensatory and punitive
				damages and shall specifically also entitle SECH to equitable relief
				(including an injunction), in addition to (and not in substitution or
				replacement for) any other available remedies at law or in equity,
				without the need for the posting of a bond or any other requirement.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Utility Token; No Solicitation or Offering; No Advice
			</h2>
			<p>
				SECH Tokens are digital utility tokens intended solely to facilitate
				access to and payment for goods, services, and loyalty benefits offered
				by participating resorts, clubs, and partner venues ("Partner Venues").
				The Content and the Online Platform do not constitute an offer to buy or
				sell or a solicitation of an offer to buy or sell investments,
				securities, partnership interests, commodities or any other financial
				instruments. SECH Tokens do not represent or confer: (a) any equity,
				ownership, or membership interest in SECH Technologies LLC, Secrets
				Enterprises, or any Partner Venue; (b) any right to share in profits,
				revenues, or assets; (c) any voting, governance, or management rights;
				or (d) any right to dividends, interest, or other financial returns.
			</p>
			<br/>
			<p>
				While SECH may make certain informational Content available to its
				users, under no circumstances does SECH provide legal, tax, investment,
				financial, estate-planning, accounting, or any other advice. The Content
				and the Online Platform also do not constitute and may not be used in
				connection with, an offer or solicitation by anyone in any state or
				jurisdiction in which such an offer or solicitation is not authorized or
				permitted, or to any person to whom it is unlawful to make such offer or
				solicitation.
			</p>
			<br/>
			<p>
				The Content and the views expressed in the Content do not necessarily
				reflect the views of the Company, its directors, officers, employees,
				shareholders or any part or member thereof or of any third party.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Third-Party Websites and Content
			</h2>
			<p>
				The Online Platform may contain links or connections to third party
				websites. Any such link or connection is provided only as a convenience
				and should be used at your own risk. SECH has no control over any such
				other websites, the contents thereof or the products, services or
				policies represented. The existence of any link or other connection does
				not imply any affiliation, sponsorship, endorsement, approval,
				investigation, representation, warranty, verification or monitoring by
				SECH or create any liability on the part of SECH in respect of such link
				or connection. Your use of any such third-party websites is governed by
				the privacy policies of those sites, which we encourage you to review
				before using such sites.
			</p>
			<br/>
			<p>
				SECH will have no responsibility for any liabilities arising from or
				related to the contents of any third-party website or the use of any
				such website (including any mobile website) or the privacy policies and
				customer information practices of any such website.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Termination; Survival of Provisions
			</h2>
			<p>
				If you are not in full compliance with all of these Terms, the
				permissions granted to you under these Terms will automatically
				terminate, and in such circumstances, you are no longer permitted to use
				or access the Online Platform, the Content or any SECH Account.
			</p>
			<br/>
			<p>
				SECH may terminate your right to use the Online Platform, or block you
				from future use, at any time in its sole discretion, with or without
				cause, and without notice to you. Some circumstances in which SECH may
				exercise this right to terminate your right to use the Online Platform
				include, but are not limited to: (i) you have breached any provision of
				the Terms; (ii) you have engaged in conduct which SECH, in its sole
				discretion, considers to be unacceptable; (iii) SECH is required by law
				to do so; or (iv) SECH no longer provides the Online Platform. The above
				are only examples of circumstances in which SECH may terminate your
				right to use the Online Platform and SECH may terminate your right to
				use the Online Platform for any other reason in its sole discretion. We
				will not be liable to you due to or by reason of our termination of your
				right to use the Online Platform or the automatic termination of your
				right to use the Online Platform for non-compliance set forth above.
			</p>
			<br/>
			<p>
				Any ongoing obligations on you, and the provisions relating to: (i)
				SECH's Intellectual Property; (ii) No Solicitation or Offering; (iii)
				SECH's Remedies; (iv) Indemnification; (v) Limitation of Liability; (vi)
				General, and (vii) any other provisions designed to survive, will
				survive any termination or expiration of the Terms for any reason.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">SECH's Remedies</h2>
			<p>
				Without prejudice to SECH's other rights under the Terms, if you breach
				the Terms in any way, SECH may take such action as SECH deems
				appropriate to deal with the breach, including suspending your access to
				the Online Platform, prohibiting you from accessing the Online Platform,
				blocking computers using your IP address from accessing the Online
				Platform, contacting your internet service or other telecommunications
				provider to request that it block your access to the Online Platform and
				bringing court proceedings or taking other legal action against you. If
				you violate the Terms, SECH will be entitled, at any time, to bring an
				action or proceeding for specific performance, injunctive relief or
				other equitable relief in addition to (and not to the exclusion of or in
				substitution for) any other remedies at law or in equity.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Limitations of Liability
			</h2>
			<p>
				The Company endeavors to provide reliable access to the Service.
				However, our Online Platform is subject to various modes of failure and
				loss of data, some of which are beyond Our control.
			</p>
			<br/>
			<p>
				SECH may use automated systems in conjunction with: the receipt and
				handling of orders; the reporting of order acknowledgements,
				cancelations, and executions; the settlement of transactions; tax and
				cost basis reporting; and similar recordkeeping and reporting services
				(collectively, "Automated Systems"). The use of Automated Systems
				entails risks, including but not limited to interruption of service,
				systems of communications failures, delays in service, cyberattacks, and
				errors in the design or functionality of such Automated Systems that
				could cause damage, expense, or liability to the user. SECH makes no
				representations or warranty of any kind, express or implied, with
				respect to the selection, design, security, functionality, or operation
				of such Automated Systems. SECH expressly disclaims any representation
				that any Automated System will operate uninterrupted or be error-free.
			</p>
			<br/>
			<p>
				The Company disclaims all liability, and you acknowledge and agree that
				we will not be liable for any harm or damage to you or to any party
				resulting from the theft or unauthorized use of your user ID or
				password. You are solely responsible for all activity that occurs on or
				under your SECH Account (whether or not expressly authorized by you),
				and for maintaining the confidentiality of your login details. SECH
				shall have no liability to you or any other person for acts or omissions
				made or committed by your agent, representative or third-party service
				provider in respect of your SECH Account.
			</p>
			<br/>
			<p>
				Your use of the Online Platform is at your own risk, and on an "as-is"
				and "as-available" basis. You assume the risk of using the SECH wallet.
				We do not warrant, endorse, guarantee, or assume responsibility for any
				product or service offered by a third party including our Service
				Providers. You assume the risk of conducting transactions over the
				Internet and agree that we have no liability for security breaches
				unless we are grossly negligent.
			</p>
			<br/>
			<p>
				You assume the risk of losses due to your use of the Online Platform,
				including without limitation losses from: (i) hardware failures, (ii)
				data losses, (iii) user error, such as forgotten passwords or
				incorrectly construed smart contracts or other transactions; (iv)
				failure of or corruption of wallets; and (v) improper activities of
				others, including without limitation deploying viruses, phishing, or
				otherwise attacking the Online Platform, or your associated digital
				wallet.
			</p>
			<br/>
			<p>
				You agree that you have had whatever opportunity you deem necessary to
				investigate the Online Platform, and the laws, rules, or regulations
				that may be applicable to SECH transactions and that you are not relying
				upon any statement of law or fact made by the Company relating to the
				legality of these transactions.
			</p>
			<br/>
			<p>
				You agree that You will not consider any information you receive from
				SECH and/or its affiliates as investment advice, and that You do not
				expect to receive any investment advice from SECH and its affiliates.
				You agree that Your use of the Online Platform will not be deemed to
				create a relationship that includes the provision of or tendering of
				investment advice.
			</p>
			<br/>
			<p>
				To the full extent permitted by law, the Company hereby excludes all
				warranties of any kind, either express or implied, statutory (including,
				but not limited to, timeliness, truthfulness, sequence, completeness,
				accuracy, freedom from interruption), implied warranties arising from
				trade usage, course of dealing, course of performance, or the implied
				warranties of merchantability or fitness for a particular purpose or
				application, other than those warranties which are implied by and
				incapable of exclusion, restriction or modification under the laws
				applicable to this Agreement.
			</p>
			<br/>
			<p>
				We do not warrant that the information we provide or that is provided by
				wallet or blockchain providers is accurate, reliable, or correct; that
				the Online Platform will meet your requirements; that the Online
				Platform will be available at any time or location; that the Online
				Platform will function in an uninterrupted manner or be secure; that any
				defects or errors will be corrected; or that the services are free of
				viruses and other harmful components. Any subject matter obtained
				through the Online Platform is downloaded at your own risk – you are
				solely responsible for any damage to your property or loss of data that
				results from such download. We make no representations or warranties
				about the time required to complete the processing of a transaction.
			</p>
			<br/>
			<p>
				To the extent permitted by law, the Company (and its officers,
				directors, agents, Service Providers, and employees) shall not be liable
				for any damages or losses resulting in any way from:
			</p>
			<ul className="list-disc pl-6 space-y-2 mt-2">
				<li>
					Information or keywords you provide while using the Online Platform.
				</li>
				<li>Your use of or inability to use the Online Platform.</li>
				<li>Loss of access to SECH tokens in the Online Platform.</li>
				<li>Your failure to secure your device(s) and your account information.</li>
				<li>Interception of data or other unauthorized access to data by a third party.</li>
				<li>
					Any modification, price change, suspension, or discontinuance of the
					Online Platform.
				</li>
				<li>
					Viruses or other malicious software, glitches, bugs, errors or
					inaccuracies resulting from access to the Online Platform.
				</li>
				<li>Damage to your device(s) while using the Online Platform.</li>
				<li>
					The behavior, actions, and inactions of other users of the Online
					Platform.
				</li>
				<li>
					Actions taken by the Company in response to violations of the Terms of
					Service, Privacy Policy, and Our other policies, as amended from time
					to time.
				</li>
				<li>
					Any effects of changes in the Company's operations, policies and Terms
					of Service on you or any business you conduct, including without
					limitation the need to modify your practices to comply with such
					changes.
				</li>
				<li>
					The technical operating and transmission features of the Online
					Platform, including without limitation the transfer of unencrypted
					content over various networks.
				</li>
				<li>
					Any interactions and transactions you perform other than through the
					Mobile App, including without limitations any transactions involving
					decentralized exchanges.
				</li>
				<li>
					Acts (or failures to act) of third-party hardware, software, and
					network service providers.
				</li>
			</ul>
			<br/>
			<p>
				Each exclusion and limitation of our liability stated herein applies to
				all forms of damages or losses, whether direct, indirect, incidental,
				special, consequential, or exemplary, and including but not limited to,
				damages for loss of profits, goodwill, reputation, use, cost of
				procuring substitute goods or services, personal injury, diminution of
				value or any other intangible losses (even if the Company has been
				advised of the possibility of such damages).
			</p>
			<br/>
			<p>
				Some jurisdictions restrict the disclaimer of warranties and/or
				exclusion of damages, so such disclaimers and exclusions may not apply
				to you.
			</p>
			<br/>
			<p>
				You acknowledge and agree that we have relied on the representations,
				warranties, disclaimers, and limitations of liability in this agreement
				(which reflect a reasonable and fair allocation of risk between the
				parties and form an essential part of the bargain) in entering this
				Agreement and allowing you to access the Service, including the Online
				Platform. We would be unable to provide the Service without these
				provisions.
			</p>
			<br/>
			<p>
				SECH and its affiliates, agents, officers, and employees will not be
				liable to you under any theory of liability—whether based in contract,
				tort, negligence, strict liability, warranty, or otherwise—for any
				indirect, consequential, exemplary, incidental, punitive or special
				damages or lost profits, even if SECH has been advised of the
				possibility of such damages.
			</p>
			<br/>
			<p>
				If despite the provisions herein, the Company is found to be liable for
				damages to you or another party, our aggregate liability is limited to
				the cost of SECH tokens you purchased using the Mobile App within the
				previous six months.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Indemnification</h2>
			<p>
				You agree to indemnify and hold SECH and its affiliates, agents,
				officers, and employees from and against any suit, action, claim,
				demand, penalty or loss, including reasonable attorneys' fees and
				expenses and any amount paid in settlement to a third party, made by or
				resulting from any third party (including any government agency or body)
				due to, in connection with or arising out of (i) your use of the Online
				Platform, the Content, or your SECH Account, (ii) any breach or alleged
				or claimed breach of the Terms or the materials it incorporates by
				reference, including the Privacy Policy, (iii) your violation of any
				law, regulation, order or other legal mandate, or the rights of a third
				party, (iv) any act or omission by your agent, representative or
				third-party service provider while using your SECH Account, regardless
				of whether the specific use was expressly authorized by you, and (v) any
				transactions you perform relating to the SECH token other than
				transactions performed entirely through the Mobile App.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">For Adult Use</h2>
			<p>
				The Service is not intended for children under the age of 18 and the
				Company does not knowingly collect information from minors. We will
				close the account of any user under the age of 18 or who is otherwise
				not of legal age to use the Service.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Restricted Persons and Jurisdictions
			</h2>
			<p>
				You hereby represent and warrant that you have not been identified as a
				Specially Designated National or placed on any sanctions list by the
				U.S. Treasury Department's Office of Foreign Assets Control (OFAC), the
				U.S. Commerce Department, or the U.S. Department of State; and you will
				not use our Online Platform to conduct any illegal or illicit activity.
			</p>
			<br/>
			<p>
				You may not register a SECH Account or use the Online Platform if you
				are a resident of any jurisdiction in which (i) SECH is not authorized
				to provide the Online Platform, (ii) the United States has embargoed
				goods or services, (iii) where your use of the Online Platform would be
				illegal or otherwise violate any applicable law of such jurisdiction or
				of the United States ("Restricted Jurisdiction"). You hereby represent
				and warrant that you are not a resident of any Restricted Jurisdiction
				and that you will not register a SECH Account or use the Online Platform
				even if our methods to prevent you from registering an account or using
				the Online Platform are not effective or can be bypassed. We may
				implement controls to restrict access to the Online Platform from any
				Restricted Jurisdiction.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Transfer and Processing of Data
			</h2>
			<p>
				By accessing or using our Online Platform, you consent to the
				processing, transfer and storage of information about you in and to the
				United States and other countries, where you may not have the same
				rights and protections as you do under local law.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Fair Practices</h2>
			<p>
				You agree not to: (i) make any representations, warranties or guarantees
				on SECH's behalf or with respect to the SECH token, the Online Platform,
				or any content or data contained on the Online Platform; (ii) make any
				false or misleading representations with regard to SECH tokens, the
				Company, or the Online Platform or any content or data contained on the
				Online Platform; or (iii) participate or engage in any illegal,
				deceptive, misleading, fraudulent, unethical or improper practices on,
				through, by means of or with respect to the Online Platform or that
				relate to the SECH token.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Assignment</h2>
			<p>
				You acknowledge and agree that you may not assign, delegate, sub-contract
				or otherwise transfer your rights or obligations under the Terms. SECH
				may transfer, assign, delegate, sub-contract or otherwise transfer its
				rights and obligations under the Terms without notifying you or
				obtaining your consent.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Disputes and Arbitration Procedures
			</h2>
			<p>
				Notwithstanding the provisions above, any claim or dispute arising
				between you and SECH that relates in any way to this Agreement, your use
				of or access to the Online Platform, actions by SECH or its agents, or
				any transaction through the Online Platform, will be resolved
				exclusively through final and binding arbitration, rather than in court.
				Any judgment on the award rendered by the arbitrator may be entered in
				any court of competent jurisdiction. The parties agree that they will
				not appeal any arbitration decision to any court.
			</p>
			<br/>
			<p>
				As an alternative, you may file a claim in small claims court, if your
				claims qualify and so long as the matter remains in such court and
				advances only on an individual (non-class, non-representative) basis.
			</p>
			<br/>
			<p>
				<span className="font-medium">Equitable Remedies:</span> Notwithstanding
				the foregoing, SECH may seek and obtain injunctive relief in any court
				of competent jurisdiction.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Prohibition of Class and Representative Actions and Jury Trials
			</h2>
			<p className="uppercase font-semibold">
				YOU AND SECH MAY BRING CLAIMS AGAINST THE OTHER ONLY ON AN INDIVIDUAL
				BASIS AND NOT IN A CLASS ACTION OR OTHER REPRESENTATIVE STATUS. THE
				ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON'S OR PARTY'S
				CLAIMS OR PRESIDE OVER ANY CONSOLIDATED, REPRESENTATIVE, OR CLASS
				PROCEEDING. THE ARBITRATOR MAY AWARD RELIEF ONLY TO THE INDIVIDUAL PARTY
				SEEKING RELIEF FOR THAT PARTY'S INDIVIDUAL CLAIMS. YOU EXPRESSLY WAIVE
				ANY RIGHT TO A JURY TRIAL.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Arbitration Procedure</h2>
			<p>
				The arbitration will be conducted by the American Arbitration
				Association ("AAA") under its Consumer Arbitration Rules as modified by
				this Agreement. The AAA's rules are available at{' '}
				<a href="https://www.adr.org" className="text-[#EF4444] hover:text-[#DC2626]">
					www.adr.org
				</a>
				.
			</p>
			<br/>
			<p>
				A party who intends to seek arbitration must first send to the other a
				Notice of Dispute ("Notice") describing the nature and basis of the
				claims the party is asserting and the relief sought. A Notice to SECH
				must be sent by certified mail to SECH Technologies LLC, Attn: Notice of
				Dispute. SECH will send any Notice to the email address on file for Your
				SECH account; it is Your responsibility to keep your email functional
				and keep Your email address up to date.
			</p>
			<br/>
			<p>
				If You and SECH are unable to resolve the claims in the Notice within 30
				days after the Notice is sent, either party may initiate arbitration
				proceedings. A form for initiating arbitration proceedings is available
				at{' '}
				<a href="https://www.adr.org" className="text-[#EF4444] hover:text-[#DC2626]">
					www.adr.org
				</a>
				. In addition to filing this form with the AAA in accordance with its
				rules and procedures, the party initiating the arbitration must mail a
				copy of the completed form to the opposing party. You may send a copy to
				SECH at: SECH Technologies LLC. If SECH initiates an arbitration it will
				send a copy of the completed form to the email address on file for Your
				SECH account.
			</p>
			<br/>
			<p>
				Payment of all filing, administration and arbitrator fees will be
				governed by the AAA's rules.
			</p>
			<br/>
			<p>
				Settlement offers shall not be disclosed to the arbitrator. Any
				arbitration hearings shall be held in Orlando, Florida. If the value of
				the relief sought is $1,000 or less, either you or SECH may elect to
				have the arbitration conducted by telephone or based on written
				submissions.
			</p>
			<br/>
			<p>
				The arbitrator will decide all claims consistent with applicable law and
				will honor privileges recognized by law. The arbitrator shall not be
				bound by rulings in prior arbitrations involving other Clients. The
				arbitrator's award shall be final and binding; judgment on the award may
				be entered in any court having jurisdiction thereof.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">Opt-Out Procedure</h2>
			<p className="uppercase font-semibold">
				YOU CAN REJECT THE ARBITRATION REQUIREMENT HEREIN BY EMAILING SECH A
				WRITTEN NOTICE NO LATER THAN 30 DAYS AFTER THE DATE YOU OPEN AN ACCOUNT
				FOR THE FIRST TIME.
			</p>
			<br/>
			<p>
				The Notice must include your name, street address, city, state and zip
				code, and the user ID(s) and email address(es) associated with the SECH
				account(s) to which the opt-out applies. This is the only way to opt out
				of arbitration; the rest of this Agreement will continue to apply.
				Opting out of arbitration as provided in this version of the Agreement
				has no effect on any other or future arbitration agreements you may have
				with SECH.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">General Terms</h2>
			<p>
				If the arbitration provisions above are found not to apply to your
				claim, the state and Federal courts located in Orlando, Florida will
				have exclusive jurisdiction, and you agree to submit to the personal
				jurisdiction of these courts. In that event, You and we each waive any
				objection to venue in the Orlando, Florida courts and agree not to plead
				or claim in any of these courts that such litigation brought therein has
				been brought in an inconvenient forum or that there are indispensable
				parties to such litigation that are not subject to the jurisdiction of
				the courts.
			</p>
			<br/>
			<p>
				The Terms and all disputes, claims or controversies (whether in tort,
				contract or otherwise) arising out of or relating in any way to the
				Terms, the Online Platform or the Content, the negotiation,
				interpretation, validity or performance of the Terms, the rights and
				obligations of you and us hereunder or any transaction contemplated by
				the Online Platform shall be governed by and construed in accordance
				with the laws of the State of Florida without regard to the rules or
				principles of conflict of laws of such State or any other jurisdiction
				that would permit or require the application of the laws of any other
				jurisdiction.
			</p>
			<br/>
			<p>
				You agree that regardless of any statute or law to the contrary, any
				claim or cause of action arising out of or related to use of the
				Service, the Services, this Agreement, or the Privacy Policy must be
				filed within one (1) year after such claim or cause of action arose or
				be forever barred.
			</p>
			<br/>
			<p>
				All rights in the Online Platform not otherwise expressly granted to you
				by the Terms are reserved to SECH. The Terms, together with the Privacy
				Policy, constitute the sole and entire agreement between you and us with
				respect to the subject matter hereof and supersedes all other prior or
				contemporaneous negotiations, discussions, agreements, understandings,
				representations and warranties, both written and oral, between you and
				us with respect to such subject matter. You agree that no joint venture,
				partnership, employment, or agency relationship exists between you and
				SECH as a result of the Terms or any use of the Online Platform. The
				failure of SECH to exercise or enforce any right or provision of the
				Terms shall not constitute a waiver of such right or provision. If any
				provision of the Terms is found by a court of competent jurisdiction to
				be invalid, void, unlawful or unenforceable, the Parties agree that the
				court should give effect to the Parties' intentions as reflected in such
				provision, and the other provisions of the Terms shall remain in full
				force and effect. The section titles in the Terms are for convenience
				only and have no legal or contractual effect. Neither the course of
				conduct between you and SECH, nor trade practice, shall act to modify
				any provision of the Terms. For purposes of the Terms, the terms
				include, includes, including, such as, and for example, shall be
				construed as if each term were followed by the words, without
				limitation. Except where context requires otherwise, use of the singular
				form of any noun includes the plural, and use of the plural includes the
				singular.
			</p>
		</section>

		<section>
			<h2 className="text-2xl font-semibold mt-8 mb-2">
				Questions or Comments; Our Contact Information
			</h2>
			<p>
				If there are any questions regarding our Terms of Service, you may
				contact us using the following information:
			</p>
			<br/>
			<p>
				<strong>Email:</strong>{' '}
				<a href="mailto:support@sech.io" className="text-[#EF4444] hover:text-[#DC2626]">
					support@sech.io
				</a>
			</p>
		</section>
		</div>
	</div>
)

export default TermsPage